import { elements } from '../../../dom';

type TitleFieldsOptions = {
  onSubtitleInput: (subtitle: string) => void;
  onTitleInput: (title: string) => void;
};

export function createTitleFields({ onSubtitleInput, onTitleInput }: TitleFieldsOptions) {
  let setupDisabled = false;

  elements.titleInput.addEventListener('input', () => {
    if (setupDisabled) {
      return;
    }

    onTitleInput(elements.titleInput.value.trim());
  });

  elements.subtitleInput.addEventListener('input', () => {
    if (setupDisabled) {
      return;
    }

    onSubtitleInput(elements.subtitleInput.value.trim());
  });

  elements.addSubtitleButton.addEventListener('click', () => {
    if (setupDisabled) {
      return;
    }

    elements.subtitleField.hidden = false;
    elements.addSubtitleButton.hidden = true;
    elements.subtitleInput.focus();
  });

  return {
    setPlaceholder(title: string) {
      elements.titleInput.placeholder = title;
    },
    setTitle(title: string) {
      elements.titleInput.value = title;
    },
    setSetupDisabled(isDisabled: boolean) {
      setupDisabled = isDisabled;
      elements.titleInput.disabled = isDisabled;
      elements.subtitleInput.disabled = isDisabled;
      elements.addSubtitleButton.disabled = isDisabled;
    },
  };
}
